export function unescapeScriptTags(text: string): string {
  return text
    .replace(/_scriptstart_/g, "<script>")
    .replace(/_scriptend_/g, "</script>");
}
